
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import EchangeForm from '@/components/forms/EchangeForm.vue'
import VueScrollTo from 'vue-scrollto'

const prospectModule = namespace('prospect')
const echangeModule = namespace('echange')

@Component({
  components: {
    BaseCardContainer,
    EchangeForm
  }
})
export default class ProspectContactUpdate extends Vue {
  @echangeModule.Getter('echangeGetter') echange: any
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @echangeModule.Action('getEchangeByIdAction') getEchangeById: any
  @echangeModule.Action('updateEchangeAction') updateEchange: any

  get relation() {
    return {
      to: 'prospect',
      key: 'ID_PROSPECT',
      value: this.$route.params.id
    }
  }

  @Watch('$route.params.echangeId', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getEchangeById(newVal)
  }

  mounted() {
    this.getEchangeById(this.$route.params.echangeId)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  onSubmit(data: any) {
    this.updateEchange({
      id: this.$route.params.echangeId,
      formParams: data
    }).then(async (data: any) => {
      await this.getProspectById(this.$route.params.id)
      this.$router.push({name: 'prospectEchange', params: {id: this.$route.params.id}})
    })
  }

  onCancel() {
    this.$router.push({name: 'prospectEchange', params: {id: this.$route.params.id}})
  }
}
